import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingCarousel from '../../components/LandingCarousel';

function LandingPage() {
    const navigate = useNavigate();
    return (
      <div
      style={{
        minHeight: '100vh',
        background: "linear-gradient(326.23deg, #A29EDA -46.9%, #916CB4 -29.33%, #8E3A88 27.57%, #6B3A8F 73.58%, #5D2A79 115.7%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
        display: 'flex',
      }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
          }}
        >
          <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
            }}
            >
            <img
                src="/logo.svg"
                alt="Algo Olio Logo"
                style={{ width: '20%', height: 'auto', marginBottom: '1rem' }}
            />
            <h1
                style={{
                    fontFamily: "'Quicksand', sans-serif",
                    fontWeight: 500,
                    fontSize: '75px',
                    lineHeight: '112%',
                    letterSpacing: '0',
                    verticalAlign: 'middle',
                    margin: 0,
                    marginBottom: '0.5rem',
                    color: 'white'
                }}
                >
                AlgoOlio
            </h1>
            <p 
                style={{
                    fontFamily: "Plus Jakarta Sans",
                    fontWeight: 400,
                    fontSize: '20px',
                    lineHeight: '140%',
                    letterSpacing: '0',
                    color: 'white'
                    }}
                >
                Your recipe for success in technical interviews
            </p>
            <button
                style={{
                padding: '1rem 2rem',
                borderRadius: '999px',
                background: '#F0F0F0',
                boxShadow:
                    '0px 4px 8px 0px #00000026, 0px 14px 14px 0px #00000021, 0px 32px 19px 0px #00000014, 0px 57px 23px 0px #00000005, 0px 89px 25px 0px #00000000',
                border: 'none',
                fontSize: '1rem',
                cursor: 'pointer',
                }}
                onClick={() => navigate('/login')}
            >
                Get started!
            </button>
            </div>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
          }}
        >
          <LandingCarousel />
        </div>
      </div>
    );
  }
  
  export default LandingPage;